export { SESSION_STATUS } from '@or-sdk/hitl';
export * from './agents';
export * from './common';
export * from './session-events';
export * from './layout';

export const LOCAL_STORAGE_KEYS = {
  AGENT_UI_SETTINGS: 'Agent-UI-Settings',
  SESSION_VIEWS: 'Session-Views',
  EVENT_TEMPLATES: 'Event-Templates',
  ACW_SETTINGS: 'ACW-settings',
  LAYOUT_SETTINGS: 'UI-Layout-Settings',
  LAUNCHER_SETTINGS: 'App-Launcher-Settings',
  UPDATE_STATUS: 'HITL-Update-Status',
  MIGRATIONS: 'HITL-Migrations',
  AGENT_DATA: 'Agent-Data',
  CARDS_DATA: 'Cards-Data',
  /** TODO: Delete when workspace settings store is updated */
  LAYOUT: 'HITL_LOCAL_SETTINGS',
};
